/* src/app/components/payroll/corrections/revert-adjustment/revert-adjustment.component.css */
.table-style {
  width: 100%;
}
/*# sourceMappingURL=revert-adjustment.component-Y3PD3RO6.css.map */
